import Manufacturer, {
  IManufacturerCreateUpdate,
  IManufacturerCreateUpdateApiModel,
} from '@models/Manufacturer.model';
import Product, {
  IProductCreateUpdate,
  IProductCreateUpdateApiModel,
} from '@models/Product.model';

import { api } from '@services';

interface IRequest {
  products: IProductCreateUpdateApiModel[];
  manufacturers: IManufacturerCreateUpdateApiModel[];
}

interface IResponse {
  products: IProductCreateUpdate[];
  manufacturers: IManufacturerCreateUpdate[];
}

const getUpdateRelations = async (id?: string): Promise<IResponse> => {
  if (!id) {
    return {
      manufacturers: [],
      products: [],
    };
  }

  const { data } = await api.get<IRequest>(`/updates/${id}/relations`);

  const products = Product.arrayFromCreateUpdateApiModel(data.products);
  const manufacturers = Manufacturer.arrayFromCreateUpdateApiModel(
    data.manufacturers,
  );

  return {
    products,
    manufacturers,
  };
};

export { getUpdateRelations };
